import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-mensaje-registro',
  templateUrl: './mensaje-registro.component.html',
  styleUrls: ['./mensaje-registro.component.scss']
})
export class MensajeRegistroComponent implements OnInit {
  flagMessage: number;
  flagBotonAceptar: boolean;

  constructor(private router: Router,
              private globals: Globals) { }

  ngOnInit() {
    this.flagMessage = this.globals.tipo_form_solicitante;
    this.flagBotonAceptar = this.globals.app_title === "WT001" ? true : false;
    console.log("flagBotonAceptar",this.flagBotonAceptar);
  }

  aceptar() {
    if (this.flagBotonAceptar) {
      //this.globals.admin_msg_shared = 1;
      //this.router.navigate(['/mensaje-financiamiento']);
      this.router.navigate(['/iniciar-sesion']);
    }
  }

}
